export default "__VITE_ASSET__Bj_4yrMv__"